import _classCallCheck from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/keoadmin/agent/_work/122/s/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { Parser } from "../Parser.mjs";
import { dayPeriodEnumToHours } from "../utils.mjs";
export var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "priority", 80);
    _defineProperty(_assertThisInitialized(_this), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case "b":
        case "bb":
        case "bbb":
          return match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return match.dayPeriod(dateString, {
            width: "wide",
            context: "formatting"
          }) || match.dayPeriod(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match.dayPeriod(dateString, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);